<template>
  <div>
    <a-row>
      <a-card>
        <g-master name="forms"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :parentData="parentData"
                  :beforeSend="master.beforeSend"
                  :actions="false"
                  ref="master"
        >
          <template slot="masterModal" slot-scope="{record}">
          </template>
        </g-master>
      </a-card>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tipoRecomendacion: {h_lookup_type: 'TYPE_MEDICAL_RECOMMEN', use_code: true},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'cases',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'id_case'
            },
            columns: [
              {title: 'ID Caso', dataIndex: 'id_case', sorter: true},
              {title: 'Estado 1', dataIndex: 'desestatus1', sorter: true},
              {title: 'Estado 2', dataIndex: 'desestatus2', sorter: true},
              {title: 'Fecha de calificación', dataIndex: 'fecha_calificacion', sorter: true},
              {title: 'Observación caso', dataIndex: 'observation', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by'},
              {title: 'Creado el', dataIndex: 'created_on'}
            ]
          }
        }
      }
    },
    props: ['empleadoseleccionado'],
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/CasosReportados.vue